import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationApi {
  private readonly propertyNotificationsApi = 'notifications';
  private readonly propertyNotificationStatusApi = 'notifications/status';
  private readonly userNotificationsApi = 'user-notifications';
  private readonly userNotificationStatusApi = 'user-notifications/status';

  prospektrBackendBaseURL = environment.prospektrBackendBaseURL;


  constructor(private http: HttpClient) { }

  getNotificationProperty(params: any): Observable<any> {
    return this.http
      .post(
        this.prospektrBackendBaseURL + this.propertyNotificationsApi,
        params || {}
      )
      .pipe(take(1));
  }

  UpdateNotificationStatusChange(params: any): Observable<any> {
    return this.http
      .patch(
        this.prospektrBackendBaseURL + this.propertyNotificationStatusApi,
        params
      )
      .pipe(take(1));
  }

  getUserNotifications(params: any = {}): Observable<any> {
    return this.http
      .post(
        this.prospektrBackendBaseURL + this.userNotificationsApi,
        params
      )
      .pipe(take(1));
  }

  updateUserNotificationStatus(notificationIds: string[]): Observable<any> {
    return this.http
      .patch(
        this.prospektrBackendBaseURL + this.userNotificationStatusApi,
        { ids: notificationIds }
      )
      .pipe(take(1));
  }
}
